import * as React from 'react';
import { FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';
import { MainModal } from '..';
import { Button, Title } from '../styled';
import { modalActions } from '../../store/ducks/modal';
import { redirectWithQueryParams, PagePath } from '../../helpers/util';

const mapStateToProps = (state: any) => ({
  startFreeTrialModal: state.modalData.startFreeTrialModal,
  locationQuery: state.router.location.query,
});

interface DispatchProps {
  toggleStartFreeTrialModal: (isOpen: boolean) => void;
}
type StateProps = ReturnType<typeof mapStateToProps>;
type Props = StateProps & DispatchProps;

class StartFreeTrialModal extends React.Component<Props> {
  handleMySubscriptions = () => {
    this.props.toggleStartFreeTrialModal(false);
    redirectWithQueryParams(PagePath.mySubscriptions, this.props.locationQuery);
  };

  render() {
    return (
      <MainModal contentLabel="Start Subscription Modal" isOpen={this.props.startFreeTrialModal} >
        <Title><FormattedMessage id="free_trial_started" /></Title>
        <small><FormattedMessage id="free_trial_started_description" /></small>
        <br />
        <Button onClick={this.handleMySubscriptions}><FormattedMessage id="ok" /></Button>
      </MainModal>
    );
  }
}

export default connect<StateProps, DispatchProps>(mapStateToProps, modalActions)(StartFreeTrialModal);
